import { EntityName, Page } from '@/components';
import { tokensMapping } from '@/utils/tokens';
import { CryptoIcon, Heading } from '@blockanalitica/ui';
import STUSDSEventsTable from './stUSDSEventsTable';
import STUSDSDepositorsVolumeChart from './stUSDSVolumeChart';

export default function STUSDSDepositorsActivityPage() {
  return (
    <Page
      title={
        <EntityName
          symbol1={
            <CryptoIcon
              name={'stUSDS'}
              address={tokensMapping('stUSDS').address}
              size="4"
            />
          }>
          <Heading size="1">stUSDS Activity</Heading>
        </EntityName>
      }>
      <STUSDSDepositorsVolumeChart />
      <STUSDSEventsTable />
    </Page>
  );
}
